import { PRODUCT_TYPES } from '@/lib/constants';
import { ProductType } from '@/types/store';

export type EditorTabKeys = 'STORE_PRESENTATION' | 'PRODUCT' | 'COURSE' | 'MEETING' | 'WEBINAR' | 'OPTIONS';

export const EDITOR_TABS: Record<
    EditorTabKeys,
    { id: string; label: string; location: string[]; productType?: ProductType }
> = {
    STORE_PRESENTATION: {
        id: 'STORE_PRESENTATION',
        label: 'Store',
        location: ['store'],
    },
    PRODUCT: {
        id: 'PRODUCT',
        label: 'Product',
        location: ['store', 'landing'],
    },
    COURSE: {
        id: 'COURSE',
        label: 'Course',
        location: ['store', 'landing'],
        productType: PRODUCT_TYPES.COURSE,
    },
    MEETING: {
        id: 'MEETING',
        label: 'Meeting',
        location: ['store', 'landing'],
        productType: PRODUCT_TYPES.BOOKING,
    },
    WEBINAR: {
        id: 'WEBINAR',
        label: 'Webinar',
        location: ['store', 'landing'],
        productType: PRODUCT_TYPES.WEBINAR,
    },
    OPTIONS: {
        id: 'OPTIONS',
        label: 'Options',
        location: ['store', 'landing'],
    },
};
